import { useEffect, useState } from "react";

import {
  DocumentList,
  InfoPanel,
  Typography,
} from "@king-ict/eupisi-ui/components";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import styles from "./Dashboard.module.scss";
import {
  getAnnouncementList,
  getAnnouncementDocumentById,
} from "../../api/Announcement/AnnouncementApi";
import { ContentArea } from "../../components";
import { Announcement } from "../../models/Announcement";
import { Attachment } from "../../models/Shared/Attachment";

export function Dashboard() {
  const { t } = useTranslation();

  const [gotAnyResults, setAnyResults] = useState<boolean>(false);
  const [announcements, setAnnouncements] = useState<Announcement[]>([]);

  useEffect(() => search(), []);
  const search = () => {
    (async () => {
      var itemList = await getAnnouncementList();
      if (itemList !== null && itemList.length > 0) {
        setAnyResults(true);
        setAnnouncements(itemList);
      } else {
        setAnyResults(false);
        setAnnouncements([]);
      }
    })();
  };
  function hrDateWithTime(date: Date) {
    return new Date(date).toLocaleString("hr-HR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  }
  const handleGetDocument = (doc: Attachment) => {
    if (doc && doc.id) {
      getAnnouncementDocumentById(doc.id);
    }
  };

  const getAnnouncementMessage = (itemList: Announcement[]) => {
    return (
      <>
        {itemList.map((val) => (
          <Row key={val.id} className="mt-1 pt-0">
            <Col md={12}>
              <InfoPanel
                color={val.isSticky ? `info` : `light`}
                message=""
                fullWidth={true}
                showIcon={false}
              >
                <p className={styles.announcementHeading}>{val.title}</p>
                <hr className={styles.divider} />
                <p className={styles.announcementDate}>
                  {hrDateWithTime(val.dateFrom)}
                </p>
                <br />
                <div
                  className={styles.announcementMessage}
                  dangerouslySetInnerHTML={{ __html: val.text }}
                />
                <br />
                <br />
                <DocumentList
                  removable={false}
                  documents={val.attachments ?? []}
                  onDocumentClick={handleGetDocument}
                />
              </InfoPanel>
            </Col>
          </Row>
        ))}
      </>
    );
  };

  return (
    <ContentArea>
      {gotAnyResults && <>{getAnnouncementMessage(announcements)}</>}
      {!gotAnyResults && (
        <Row className="mt-4">
          <Col md={12} className={styles.emptyList}>
            <Typography variant="largeBold" component="h2">
              {t("common.noData")}
            </Typography>
          </Col>
        </Row>
      )}
    </ContentArea>
  );
}
